import { Fragment } from 'react/jsx-runtime';

import InfoButton from './InfoButton';

import Coins from '@/assets/ic_coins.svg';
import Dots from '@/assets/ic_puntitos.svg';
import Field from '@/assets/ic_soccer_field.svg';
import { Button } from '@/components';
import useTapTourney from '@/hooks/useTapTourney';
import { ParticipacionTapTo, TAPorPremioTO } from '@/types/tda';

interface TournamentHomeContentProps {
  showTourneyList: boolean;
  dataInit:
    | {
        abiertos?: TAPorPremioTO[];
        participaciones?: ParticipacionTapTo[] | undefined;
        llenoFormBancario?: boolean;
      }
    | null
    | undefined;
  isMobile: boolean;
  isDesktop: boolean;
  productCard: (item: TAPorPremioTO, index: number) => JSX.Element;
  setShowTourneyList: React.Dispatch<React.SetStateAction<boolean>>;
}

const TournamentHomeContent = ({
  showTourneyList,
  dataInit,
  isMobile,
  isDesktop,
  productCard,
  setShowTourneyList,
}: TournamentHomeContentProps) => {
  const { updateTapProperties } = useTapTourney();

  const handleIsOpenInfo = (boolean: boolean) => {
    updateTapProperties({
      isOpenInfo: boolean,
    });
  };

  if (showTourneyList) {
    return null;
  }

  return (
    <>
      {dataInit?.abiertos && dataInit.abiertos.length > 0 && (
        <div className="flex flex-col md:flex-row justify-between mt-6 gap-y-6 md:gap-12">
          {dataInit.abiertos
            .slice()
            .reverse()
            .map((item, index) => (
              <Fragment key={item.id ?? index}>
                {productCard(item, index)}
              </Fragment>
            ))}
        </div>
      )}

      {isMobile && (
        <div className="flex items-center justify-center">
          <InfoButton handleIsOpenInfo={handleIsOpenInfo} hideButton={false} />
        </div>
      )}

      {isDesktop && (
        <>
          <p className="font-bold text-[16px]">¿Cómo participar?</p>
          <div className="bg-white rounded-md flex justify-between mt-6 gap-12 py-4 px-8 h-[136px]">
            <div className="w-[320px] border-r border-gray-200">
              <div className="p-3 bg-[#E3EAFF] rounded-full w-10 mb-2">
                <img alt="ic Calendar" className="w-20" src={Dots} />
              </div>
              <p className="text-[14px] font-semibold">
                Elegí en qué torneo querés anotarte y accedé con tu Pin
                especial.
              </p>
            </div>
            <div className="w-[310px] px-1 border-r border-gray-200">
              <div className="p-3 bg-[#E3EAFF] rounded-full w-10 mb-2">
                <img alt="ic Calendar" className="w-20" src={Field} />
              </div>
              <p className="text-[14px] font-semibold">
                Jugás con tu equipo de Primera.
              </p>
            </div>
            <div className="w-[330px]">
              <div className="p-3 bg-[#E3EAFF] rounded-full w-10 mb-2">
                <img alt="ic Calendar" className="w-20" src={Coins} />
              </div>
              <p className="text-[14px] font-semibold">
                Arrancan todos en la misma fecha. La competencia va hasta el
                final de Gran DT.
              </p>
            </div>
          </div>
          <div className="flex items-center justify-center mt-10 gap-x-8">
            {(dataInit?.participaciones?.length ?? 0) > 0 && (
              <Button
                type="button"
                variant="primary"
                onClick={() => {
                  setShowTourneyList(true);
                }}
              >
                Ir a mis Torneos de Amigos por Premios
              </Button>
            )}
            <InfoButton
              handleIsOpenInfo={handleIsOpenInfo}
              hideButton={false}
            />
          </div>
        </>
      )}
    </>
  );
};

export default TournamentHomeContent;
